import Vue from 'vue'
import App from './App.vue'
import kim from './kim'

Vue.use(kim)

Vue.config.productionTip = false




new Vue({
  render: h => h(App),
}).$mount('#app')


// npm publish --registry=https://registry.npmjs.org/